import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  labelColor?: string;
  leftValue?: string;
  bottomValue?: string;
  border?: boolean;
  selected?: boolean;
  width?:string;
}


export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
`

export const BoxContainer = styled.div`
  position: relative;
  width: 1200px;
  height: 750px;
  padding: 0px 0px 44.5px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  padding: 20px 60px 15px 33px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`
export const Title = styled.div`
  padding: 0px 0px 11px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SubtitleContainer = styled.div`
  display: flex;
`

export const Subtitle = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const Hour = styled.div`
  padding: 0px 0px 0px 12px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.MID_GRAY};
`

export const RightSide = styled.div`
  color: ${(props: IRootProps) => props.labelColor ? props.labelColor : "#f5bc00"};
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const Content = styled.div`
  width: 95%;  
  height: 480px;
  overflow-y: auto;
  border-radius: 5px;
  background-color: #282828;
  margin:10px 30px 0 30px;
  display:flex;
  justify-content:center;
`

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 60px;
  bottom: 48px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`

export const PreviewContent = styled.div`
  width: ${(props: IRootProps) => props.width ? props.width : "100%"};  
  height: 100%;    
  display:flex;
  justify-content:center;
`;

export const TagsContainer = styled.div`
  display:flex;
  flex-direction:row;
  margin-left:30px;
  margin-top:15px;
  white-space: nowrap;
  overflow-y:none;
  overflow-x:hidden;
  max-width:95%;
`;


export const TagItem = styled.div`
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin-right:10px;
  display:flex;
`;

export const CustomTagsTitle = styled.div`
  font-family: Roboto;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin-left:30px;
  margin-top:20px;
`;

export const CustomContainer = styled.div`
  display:flex;  
  margin-left:30px;
  margin-top:10px;
  flex-direction:row;   
  width:650px;
  height:70px;  
`;

export const CustomTagsContainer = styled.div`
  display:flex;  
  flex-wrap: wrap;    
  max-width:600px;
  max-height:70px;
  overflow:hidden;
`;

export const CustomTagsCounter = styled.div`
  display:flex;  
  flex-wrap: wrap;    
  width:50px;
  height:70px;
  align-items: flex-end;
  
`;


export const CustomTagItem = styled.div`
  border-radius: 20px;
  background-color: #204078;
  padding:8px;
  margin:5px 5px 0 0;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  text-align:center;
  cursor:pointer;
  height:14px;

`;


export const SubtitleBold = styled.div`
  margin: 0px 0px 0px 5px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #122442;
`;

export const FormatsAbsoluteContainer = styled.div`
  position: fixed;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '0px')};
  bottom: ${(props: IRootProps) => (props.bottomValue ? props.bottomValue : '-30px')};
  display: flex;
  justify-content: center;
  z-index: 1000;
  max-height: 0px;
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  ${SubtitleBold}:hover & {
    display: flex;
    opacity: 1;
    max-height: 1000px;
    transition-delay: 0.5s;
  }
`;

export const FormatsContainer = styled.div`
  margin: 1.7px 0 0;
  padding: 13px 0px 0px;
  border-radius: 2px;
  background-color: ${C.DARKEST_GRAY};
`;

export const FormatLabel = styled.div`
  padding: 0px 20px 13px 20px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARKER_WHITE};
`;



export const CustomTagsAbsoluteContainer = styled.div`
  position: fixed;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '0px')};
  bottom: ${(props: IRootProps) => (props.bottomValue ? props.bottomValue : '-30px')};
  display: flex;  
  width: 130px;
  height: 120px;  
  border-radius: 5px;
  background-color: #204078;  
  overflow-y: auto;    
  border-radius: 5px;
  flex-direction:column;
`;

export const CustomTagsExtraContainer = styled.div`
  display: flex;  
  width: 100%;
  height: 100%;
 
`;

export const CustomTagItemExtra = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background-color: #204078;
  padding: 8px 8px 8px 10px;    
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;  
  color: #fff;
  text-align:left;
  cursor:pointer;  
`;
